module.exports = __webpack_public_path__ + "static/media/son-thumbnailDT.b47c843a.jpg";